import React from "react";
import styles from "./ConfirmDialog.module.css";

const ConfirmDialog = ({
  isOpen,
  title = "تأكيد الحذف",
  message,
  confirmLabel = "حذف",
  cancelLabel = "إلغاء",
  loading = false,
  onConfirm,
  onCancel,
}) => {
  if (!isOpen) return null;

  return (
    <div className={styles.overlay} onClick={onCancel}>
      <div className={styles.dialog} onClick={(e) => e.stopPropagation()} dir="rtl">
        <h4 className={styles.title}>{title}</h4>
        <p className={styles.message}>{message}</p>

        <div className={styles.actions}>
          <button className={styles.cancelBtn} onClick={onCancel} disabled={loading}>
            {cancelLabel}
          </button>
          <button className={styles.confirmBtn} onClick={onConfirm} disabled={loading}>
            {loading ? "جارِ الحذف..." : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;